import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function getHmlReport(upload_id, file_name, file_type) {
  if (!upload_id) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: "Invalid request. upload_id is missing." },
        "Invalid request. upload_id is missing.",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/hml_${file_type}_report/${upload_id}`;

    const res = await fetch(path, {
      method: "GET",
      credentials: "include",
    });

    if (!res.ok) {
      const fallback = `Failed to download HML report (status: ${res.status})`;

      let parsed = null;
      try {
        parsed = await res.json();
      } catch {
        parsed = null;
      }

      return {
        success: false,
        ...normalizeApiMessage(parsed, fallback),
      };
    }

    const blob = await res.blob();

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${file_name}.hml`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);

    return {
      success: true,
      ...normalizeApiMessage(
        { message: "HML report downloaded successfully." },
        "HML report downloaded successfully.",
      ),
    };
  } catch (error) {
    console.error("HML report request failed:", error);
    return {
      success: false,
      ...normalizeApiMessage(
        { message: error.message || "HML report request failed." },
        error.message || "HML report request failed.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
